/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Breadcrumb, Button, Input, Radio, RadioGroup, Select, SelectOption, Checkbox, Panel,
} from 'appkit-react';
import {
    Col, Row, Alert, Card,
} from 'react-bootstrap';
import ReactSelect from 'react-select';

import TenantMappingDeleteWarningModal from './TenantMappingDeleteWarningModal';
import '../styles/createUser.scss';

const customStyle = { width: 'content-fit', marginLeft: '0.5rem', marginRight: '0.5rem' };

const CreateOrEditUser = ({
    history, breadcrumbItems, userRoles, addUserToProductLoading,
    editUserLoading, updateUserLoading, changeRoleLoading,
    changeStatusLoading, validateEmail, validateFirstName, validateLastName, onSave,
    showErrorAlert, setShowErrorAlert, errorMsg, userStatus, setUserStatus, setUserRole,
    userRole, firstName, setFirstName, firstNameError, setIAMUserRole, iamUserRole,
    grantAdminRights, setGrantAdminRights,
    email, setEmail, emailError, lastName, setLastName, lastNameError, jobTitle,
    setJobTitle, jobDepartment, setJobDepartment, successMsg, showSuccessAlert,
    setShowSuccessAlert, showWarningMessage, defaultTenant, setShowWarningMessage,
    warnMsg, tenant, isSelfLoggedIn, userMappedTenants, assignTenantChange,
    showAddTenantPanel, setTenant, tenants, onEdit, editTenant,
    showEditTenantPanel, setShowEditTenantPanel, onUpdateTenant, onAssignTenant,
    setShowAddTenantPanel, onDelete, showConfirmDelete, setShowConfirmDelete,
    setConfirmReset, setErrorMsg, userData, setEditTenant, pageTitle,
    moduleOptions, selectedModuleIds, setSelectedModuleIds,
}) => {
    const isLoading = addUserToProductLoading || editUserLoading || updateUserLoading || changeRoleLoading || changeStatusLoading;
    return (
        <div>
            <div className="true-comply-user_management_layout">
                <div className="true-comply-user_management_column-2">
                    <Breadcrumb items={breadcrumbItems} />

                    <Row>
                        <Col md={5}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {pageTitle}
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <Button
                                className="a-btn a-btn-primary a-btn-lg "
                                kind="primary"
                                size="lg"
                                style={{ marginLeft: '2rem' }}
                                onClick={
                                    () => {
                                        onSave();
                                    }
                                }
                                isLoading={isLoading}
                            >
                                Save
                            </Button>
                            <Button className="a-btn a-btn-secondary a-btn-lg " kind="secondary" size="lg" style={{ marginLeft: '1rem' }} onClick={() => history.goBack()}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>{successMsg}</Alert>
                    )}
                    {showErrorAlert && (
                        <Alert
                            variant="danger"
                            onClose={() => {
                                setShowErrorAlert(false);
                                setErrorMsg('');
                            }}
                            dismissible="true"
                        >
                            {errorMsg}
                        </Alert>
                    )}
                    {!isSelfLoggedIn && !isLoading && userStatus === 'DISABLED' && (
                        <Alert variant="warning">User is Disabled. Please enable the user to update the other fields.</Alert>
                    )}
                    {showWarningMessage && (
                        <Alert variant="warning" dismissible onClose={() => { setShowWarningMessage(false); }}>{warnMsg}</Alert>
                    )}
                    <Accordions className="true-comply-create-user-accordion" activeItem={['panel-1']}>
                        <AccordionItem itemId="panel-1" size="lg">
                            <AccordionItemHeader className="background-white header" title="USER DETAILS" />
                            <AccordionItemBody className="background-white" size="lg">
                                <hr style={{ marginTop: 0 }} />
                                <Row style={{ paddingBottom: '2rem' }}>
                                    <Col>
                                        {/* Row 1: First Name, Last Name, Email, Admin Rights */}
                                        <Row>
                                            <Col>
                                                <label className="form-label">
                                                    FIRST NAME
                                                    <span className="required-field">*</span>
                                                </label>
                                                <Input
                                                    type="text"
                                                    name="firstName"
                                                    value={firstName}
                                                    onChange={e => {
                                                        setFirstName(e);
                                                        validateFirstName(e);
                                                    }}
                                                    hasError={firstNameError}
                                                    errMsg="FIRST NAME is required."
                                                    disabled={userStatus === 'DISABLED'}
                                                />
                                            </Col>
                                            <Col>
                                                <label className="form-label">
                                                    LAST NAME
                                                    <span className="required-field">*</span>
                                                </label>
                                                <Input
                                                    type="text"
                                                    name="lastName"
                                                    value={lastName}
                                                    onChange={e => {
                                                        setLastName(e);
                                                        validateLastName(e);
                                                    }}
                                                    hasError={lastNameError}
                                                    errMsg="LAST NAME is required."
                                                    disabled={userStatus === 'DISABLED'}
                                                />
                                            </Col>
                                            <Col>
                                                <label className="form-label">
                                                    EMAIL ID
                                                    <span className="required-field">*</span>
                                                </label>
                                                <Input
                                                    type="text"
                                                    name="email"
                                                    value={email}
                                                    onChange={e => {
                                                        setEmail(e);
                                                        validateEmail(e);
                                                    }}
                                                    hasError={emailError}
                                                    errMsg="Invalid EMAIL ID"
                                                    disabled={userData !== null}
                                                />
                                            </Col>
                                            <Col>
                                                <label className="form-label">
                                                    ADMIN RIGHTS
                                                </label>
                                                <br />
                                                <Checkbox
                                                    checked={grantAdminRights}
                                                    onChange={e => {
                                                        const isChecked = e.target.checked;
                                                        setGrantAdminRights(isChecked);
                                                        if (isChecked) {
                                                            setIAMUserRole('ADMIN');
                                                        } else {
                                                            setIAMUserRole('MEMBER');
                                                        }
                                                    }}
                                                    disabled={userStatus === 'DISABLED' || isSelfLoggedIn}
                                                >
                                                    Grant Admin Rights
                                                </Checkbox>
                                            </Col>
                                        </Row>

                                        {/* Row 2: Modules Multiselect (bound to getModules API) */}
                                        <Row style={{ paddingTop: '1rem' }}>
                                            <Col md={6}>
                                                <label className="form-label">
                                                    MODULES
                                                </label>
                                                <ReactSelect
                                                    isMulti
                                                    options={moduleOptions || []}
                                                    value={(moduleOptions || []).filter(
                                                        option => (selectedModuleIds || []).includes(option.value),
                                                    )}
                                                    onChange={selectedOptions => {
                                                        const ids = selectedOptions
                                                            ? selectedOptions.map(option => option.value)
                                                            : [];
                                                        setSelectedModuleIds(ids);
                                                    }}
                                                    classNamePrefix="react-select"
                                                    isDisabled={userStatus === 'DISABLED'}
                                                    placeholder="Select Modules..."
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />
                                            </Col>
                                        </Row>

                                        {/* Row 3: User Status (only for edit) */}
                                        {userData && (
                                            <Row style={{ paddingTop: '1rem' }}>
                                                <Col md={6}>
                                                    <label className="form-label">
                                                        USER STATUS
                                                    </label>
                                                    <RadioGroup
                                                        name="userStatus"
                                                        value={userStatus}
                                                        onChange={(event, value) => {
                                                            setUserStatus(value);
                                                        }}
                                                        style={{ display: 'flex' }}
                                                    >
                                                        <Radio
                                                            value="ENABLED"
                                                            style={{ marginRight: '1rem' }}
                                                        >
                                                            Enabled
                                                        </Radio>
                                                        <Radio
                                                            value="DISABLED"
                                                        >
                                                            Disabled
                                                        </Radio>
                                                    </RadioGroup>
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                </Row>
                            </AccordionItemBody>
                        </AccordionItem>
                    </Accordions>
                    <Panel
                        style={{ marginTop: '1rem' }}
                        title="TENANT DETAILS"
                    >
                        <Row
                            className="g-4"
                            md={3}
                            style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem' }}
                        >
                            {userMappedTenants && userMappedTenants.map((ut => (
                                <Col
                                    className="true-comply-create-user_card_row_1_col"
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                    key={ut.tenantId}
                                >
                                    <Card
                                        className="mb-2"
                                        style={customStyle}
                                        border={editTenant?.tenantId === ut.tenantId ? 'warning' : 'dark'}
                                    >
                                        <Card.Body>
                                            <Row>
                                                <Col md={1}>
                                                    <Radio
                                                        checked={ut?.tenantId === defaultTenant?.tenantId}
                                                    />
                                                </Col>
                                                <Col md={9}>
                                                    <Row>
                                                        <Col md={7} className="a-h6">
                                                            Tenant Name
                                                            <span
                                                                className="true-comply-create-user-tenant-details_label"
                                                            >
                                                                :
                                                            </span>
                                                        </Col>
                                                        <Col md={5}>
                                                            {ut?.tenant?.name}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={7} className="a-h6">
                                                            User Role
                                                            <span className="required-field">*</span>
                                                            <span
                                                                className="true-comply-create-user-tenant-details_label"
                                                            >
                                                                :
                                                            </span>
                                                        </Col>
                                                        <Col md={5}>
                                                            {ut?.userRole?.name}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={7} className="a-h6">
                                                            Job Title
                                                            <span
                                                                className="true-comply-create-user-tenant-details_label"
                                                            >
                                                                :
                                                            </span>
                                                        </Col>
                                                        <Col md={5}>
                                                            {ut?.jobTitle}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={7} className="a-h6">
                                                            Job Description
                                                            <span
                                                                className="true-comply-create-user-tenant-details_label"
                                                            >
                                                                :
                                                            </span>
                                                        </Col>
                                                        <Col md={5}>
                                                            {ut?.department}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {editTenant?.tenantId !== ut.tenantId && !showEditTenantPanel && (
                                                    <Col md={2}>
                                                        <span
                                                            className="appkiticon icon-pencil-fill"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setShowEditTenantPanel(true);
                                                                onEdit(ut);
                                                            }}
                                                            role="presentation"
                                                        />
                                                    </Col>
                                                )}
                                                {editTenant?.tenantId === ut.tenantId && !showConfirmDelete && ut?.tenantId !== defaultTenant?.tenantId && (
                                                    <Col md={2}>
                                                        <span
                                                            className="appkiticon icon-delete-outline"
                                                            style={{ color: '#333', fontSize: '1rem', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                onDelete(ut);
                                                            }}
                                                            role="presentation"
                                                        />
                                                    </Col>
                                                )}
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )))}
                        </Row>
                    </Panel>
                    {(showAddTenantPanel || showEditTenantPanel) && (
                        <Panel
                            style={{ marginTop: '1rem' }}
                            title={showEditTenantPanel ? 'EDIT TENANT' : 'ADD TENANT'}
                        >
                            <Row style={{ paddingBottom: '2rem' }}>
                                <Col>
                                    <Row>
                                        <Col>
                                            <label className="form-label">
                                                TENANT NAME
                                                <span className="required-field">*</span>
                                            </label>
                                            <Select
                                                onSelect={value => {
                                                    setTenant(value);
                                                }}
                                                value={tenant}
                                                showSearchOnList
                                                dropdownRenderMode="portal"
                                                disabled={editTenant !== null || tenant === defaultTenant?.tenantId}
                                            >
                                                {
                                                    tenants && tenants.getTenants.map(({ tenantId, name }) => <SelectOption key={tenantId} value={tenantId}>{name}</SelectOption>)
                                                }
                                            </Select>
                                        </Col>
                                        <Col>
                                            <label className="form-label">
                                                USER ROLE
                                                <span className="required-field">*</span>
                                            </label>
                                            <Select
                                                onSelect={value => setUserRole(value)}
                                                value={userRole}
                                                showSearchOnList
                                                dropdownRenderMode="portal"
                                                disabled={userStatus === 'DISABLED' || isSelfLoggedIn}
                                            >
                                                {
                                                    userRoles && userRoles.map(({ userRoleId, name }) => <SelectOption key={userRoleId} value={userRoleId}>{name}</SelectOption>)
                                                }
                                            </Select>
                                        </Col>
                                        <Col>
                                            <label className="form-label">JOB TITLE </label>
                                            <Input
                                                type="text"
                                                name="jobTitle"
                                                value={jobTitle}
                                                onChange={e => setJobTitle(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <label className="form-label">JOB DEPARTMENT </label>
                                            <Input
                                                type="text"
                                                name="jobFunction"
                                                value={jobDepartment}
                                                onChange={e => setJobDepartment(e)}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <hr />
                            <Row style={{ paddingBottom: '1rem' }}>
                                <Col style={{ textAlign: 'right' }}>
                                    <Button
                                        className="a-btn a-btn-primary a-btn-lg "
                                        kind="primary"
                                        size="lg"
                                        style={{ marginLeft: '2rem' }}
                                        onClick={
                                            () => {
                                                if (editTenant) {
                                                    onUpdateTenant();
                                                } else {
                                                    onAssignTenant();
                                                }
                                            }
                                        }
                                    >
                                        {editTenant ? 'UPDATE' : 'ADD'}
                                    </Button>
                                    <Button
                                        className="a-btn a-btn-secondary a-btn-lg"
                                        kind="secondary"
                                        size="lg"
                                        style={{ marginLeft: '1rem' }}
                                        onClick={() => {
                                            setShowAddTenantPanel(false);
                                            setShowEditTenantPanel(false);
                                            setEditTenant(null);
                                        }}
                                    >
                                        CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Panel>
                    )}
                    {!showAddTenantPanel && !showEditTenantPanel && (
                        <div style={{ marginTop: '1rem' }}>
                            <Button
                                className="a-btn a-btn-secondary a-btn-lg"
                                kind="secondary"
                                onClick={assignTenantChange}
                            >
                                <span className="appkiticon icon-plus-fill" />
                                ASSIGN TENANT
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            {showConfirmDelete && (
                <TenantMappingDeleteWarningModal
                    showConfirmDelete={showConfirmDelete}
                    setShowConfirmDelete={setShowConfirmDelete}
                    setConfirmReset={setConfirmReset}
                    setShowAddTenantPanel={setShowAddTenantPanel}
                    setShowEditTenantPanel={setShowEditTenantPanel}
                />
            )}
        </div>
    );
};

export default CreateOrEditUser;